import { render, staticRenderFns } from "./veStuAssocActivityTypeEdit.vue?vue&type=template&id=ea575866&scoped=true"
import script from "./veStuAssocActivityTypeEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea575866",
  null
  
)

export default component.exports